import { ConfirmationData } from "../../../../common/summary-common/confirmationData";

export const overWritePolicyPurposeInformation: Map<string, ConfirmationData> = new Map([
    // Agregar aquí los identificadores de preguntas o grupos para Propósito de la póliza.
]); 